export default __webpack_public_path__ + "static/cleaning-service-f56d60363604365a33400116d80e648f.png";